import HistoryService from "../../services/history.service";
import {createUrl} from "../../http";

var currentDateWithFormat = new Date().toISOString().slice(0, 10);

const state = {
    flightFolderHistoryWithZip: {},
    SummaryHistory: [],
    searchDate: currentDateWithFormat,
    SummaryVersionsData:null,
    WRjson_data : {
            RaimPredictionHTMLText :"<p>RaimPrediction data not found.</p>",
    },
    EFFjson_data : null,
    releaseModalUrl: createUrl('/TechnicalHistory/GetHistoryOfPpdfByJLVT/'),            // 'https://localhost:44333/api/TechnicalHistory/GetHistoryOfPpdfByJLVT/',
    weatherModalUrl: createUrl('/TechnicalHistory/GetWeatherchart/'),                   // 'https://localhost:44333/api/TechnicalHistory/GetWeatherchart/',
    NetlinesyncHist : [],
    NetlineChangeHistoryData : null,
    NetlineChangeHistoryOrigin : null,
};

const getDefaultState = () => {
    return {
        flightFolderHistoryWithZip: {},
        SummaryHistory: [],
        SummaryVersionsData:null,
        WRjson_data : {
            RaimPredictionHTMLText :"<p>RaimPrediction data not found.</p>",
        },
        EFFjson_data : null,
    }
};

const mutations = {

    set_jeppesen_summary_history(state, payload) {
        state.SummaryHistory = payload;
    },

    set_clear_list(state) {
        state.SummaryHistory = ''
    },

    set_flight_folder_w_zip(state, payload)
    {
        state.flightFolderHistoryWithZip = payload[0];
    },

    set_SummaryVersionsData(state,payload)
    {
        state.SummaryVersionsData = payload;
    },

    set_WRjson_data(state,payload)
    {
        state.WRjson_data = payload;
    },

    set_EFFjson_data(state,payload)
    {
        state.EFFjson_data = payload;
    },

    set_NetlineChangeHistoryData(state,payload)
    {
      state.NetlineChangeHistoryData = payload;
    },

    clear_NetlineChangeHistoryData(state)
    {
        state.NetlineChangeHistoryData = "";
    },

    set_netlinesyncHist(state,payload)
    {
        state.NetlinesyncHist = payload;
    },

    clear_netlinesyncHist(state)
    {
        state.NetlinesyncHist = [];
    },

    resetStates(state)
    {
        Object.assign(state, getDefaultState())
    },

    set_NetlineChangeHistoryOrigin(state,payload)
    {
        state.NetlineChangeHistoryOrigin = payload;
    },

    clear_NetlineChangeHistoryOrigin(state)
    {
        state.NetlineChangeHistoryOrigin = "";
    },

};
const actions = {

    async setClearList({commit})
    {
        await commit("set_clear_list");
    },

    async getNetlineSyncHistData({commit},payload)
    {
        await commit("clear_netlinesyncHist");
        const netlinesyncHist= await HistoryService.getNetlineSyncHistData_Service(payload);
        await commit("set_netlinesyncHist",netlinesyncHist);

        return netlinesyncHist;
    },

    async getSummaryVersionsData({commit},payload)
    {
        // ByFKeyForZip
        const VersionsData = await HistoryService.getTransferSummaryVersions(payload);
        await commit("set_SummaryVersionsData",VersionsData);
        await commit("set_flight_folder_w_zip",VersionsData);
        return VersionsData;
    },

    async getSummaryVersionsDataByLegno({commit}, payload)
    {
        // aynı data setine ekledik ...
        const VersionsData = await HistoryService.getTransferSummaryVersionsByLegno(payload);
        await commit("set_SummaryVersionsData",VersionsData);
        await commit("set_flight_folder_w_zip",VersionsData);
        return VersionsData;
    },

    async getNetlineChangeHistoryByLegNo({commit}, payload)
    {
        const VersionData = await HistoryService.getNetlineChangeHistoryByLegNoService(payload);
        await commit("set_NetlineChangeHistoryData",VersionData)
        return VersionData;

    },

    async GetWRjson({commit},{KFZ,STD,WLVT,flightArchiveStat})
    {
        //alert(flightArchiveStat)
        const WRjsonData = await HistoryService.GetWrJson(KFZ,STD,WLVT,flightArchiveStat);
        commit( "set_WRjson_data" , WRjsonData);
        return WRjsonData;
    },

    async GetEffJson({commit},{KFZ,STD,JLVT,flightArchiveStat})
    {
        const EffjsonData = await HistoryService.GetEffJson(KFZ,STD,JLVT,flightArchiveStat);
        commit("set_EFFjson_data", EffjsonData);
        return EffjsonData;
    },

    ClearStates({commit})
    {
        commit("resetStates");
    },

    async getNetlineChangeHistoryOrigin({commit}, payload)
    {
        const VersionData = await HistoryService.getNetlineChangeHistoryOriginService(payload);
        //alert("VersionData.length "+VersionData.length)
        await commit("set_NetlineChangeHistoryOrigin",VersionData)
        return VersionData;

    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
